import Categories from './components/Categories/Categories';
import Search from '../../sections/Search/Search';
import Advantages from './components/Advantages/Advantages';
import { advantagesData } from '../../../data/mock/avantagesData';
import Brands from './components/Brands/Brands';
import styles from './HomePage.module.scss';
import { Container } from '../../Container/Container';
import { LogoIcon } from '../../Icons/Logo';
import { useActions } from '../../../lib/hooks/useActions';
import { useNavigate } from 'react-router-dom';
import { useGetBrands } from '../../../queries/brands/useGetBrands';
import Information from './components/Information/Information';

const HomePage = () => {
  const { setFilter } = useActions();
  const navigate = useNavigate();

  const { brandsData } = useGetBrands({
    'where[isActive][equals]': 'true',
  });

  return (
    <div className={styles.HomePage}>
      <Container>
        <div className={styles.info}>
          <LogoIcon className={styles.logo} />
          <div>
            <p className={styles.description}>
              Быстрый поиск деталей, инструкций и схем для продуктов Groupe SEB
            </p>
            <h1 className={styles.title}>
              Техническая
              <br />
              документация Groupe SEB
            </h1>
          </div>
        </div>
        <Search
          onSearch={(value) => {
            setFilter({ key: 'search', value });
            navigate(`/catalog?search=${value}`);
          }}
          className={styles.search_home}
        />
        <Advantages list={advantagesData} />
        <Categories />
        {brandsData && brandsData.docs.length ? (
          <Brands
            href="/brands"
            data={brandsData.docs.map((item) => {
              return { name: item.name, image: item.image };
            })}
          />
        ) : null}
        <Information />
        <div className={styles.cover}>
          <p className={styles.coverText}>
            Инструменты SEB для ремонта и сервисного обслуживания
          </p>
          <a
            href="https://6e8ee6a6-c00b-40bb-a4ec-44a1c22bfeef.selstorage.ru/5aaa669e-9d46-4d24-a023-a3296c90bbb2.pdf"
            target="_blank"
            rel="noreferrer"
            className={styles.coverLink}
          >
            <img src="/icons/file.svg" />
            <span>Каталог.pdf</span> (672 КБ)
          </a>
        </div>
      </Container>
    </div>
  );
};

export default HomePage;
